export default __webpack_public_path__ + "static/media/outfit-gucci.8c738092.jpg";